import {
  kycAadhaarVerifyUrl,
  kycBankVerifyUrl,
  kycEmailOtpUrl,
  kycEmailVerifyUrl,
  kycFaceVerifyUrl,
  kycNationVerifyUrl,
  kycNomineeVerifyUrl,
  kycPanVerifyUrl,
  kycPassportVerifyUrl,
  kycAddPhoneUrl,
  kycTrackUrl,
  kycUpiVerifyUrl,
} from "../constant/Api";
import { baseApi } from "./api";

const kycApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    kycEmailOtp: builder.mutation({
      query: (post) => ({
        url: kycEmailOtpUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    kycEmailVerify: builder.mutation({
      query: (post) => ({
        url: kycEmailVerifyUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    kycAddPhone: builder.mutation({
      query: (post) => ({
        url: kycAddPhoneUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    kycTrack: builder.query({
      query: (post) => ({
        url: kycTrackUrl,
        method: "GET",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    kycBankVerify: builder.mutation({
      query: (post) => ({
        url: kycBankVerifyUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    kycFaceVerify: builder.mutation({
      query: (post) => ({
        url: kycFaceVerifyUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    kycPanVerify: builder.mutation({
      query: (post) => ({
        url: kycPanVerifyUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    kycNomineeVerify: builder.mutation({
      query: (post) => ({
        url: kycNomineeVerifyUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    kycUpiVerify: builder.mutation({
      query: (post) => ({
        url: kycUpiVerifyUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    kycAadhaarVerify: builder.mutation({
      query: (post) => ({
        url: kycAadhaarVerifyUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    kycNationVerify: builder.mutation({
      query: (post) => ({
        url: kycNationVerifyUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    kycPassportVerify: builder.mutation({
      query: (post) => ({
        url: kycPassportVerifyUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
  }),
});

export const {
  useKycEmailOtpMutation,
  useKycTrackQuery,
  useKycEmailVerifyMutation,
  useKycAddPhoneMutation,
  useKycAadhaarVerifyMutation,
  useKycBankVerifyMutation,
  useKycFaceVerifyMutation,
  useKycNomineeVerifyMutation,
  useKycPanVerifyMutation,
  useKycUpiVerifyMutation,
  useKycNationVerifyMutation,
  useKycPassportVerifyMutation
} = kycApi;
